import requests from "./httpServices";

export const login = async (data) => {
  return requests.post("/auth/login", data);
};

export const recovery = async (data) => {
  return requests.post("/auth/recovery", data);
};

export const recoveryWithCode = async (data) => {
  return requests.post("/auth/recoveryWithCode", data);
};

export const getUserInfoByTempToken = async (tempToken) => {
  return requests.post("/v1/get-user-info-by-temp-token", { temp_token: tempToken });
};